import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack } from '@mui/material';

import { partnerRulesQuery } from '@/entities/partner';
import { useAppQuery } from '@/shared/lib/useAppQuery';
import { Paper } from '@/shared/ui';
import { CustomTypography } from '@/shared/ui/Typography';

export function RulesTab(): ReactNode {
  const { t } = useTranslation();

  const { data: rules } = useAppQuery({ ...partnerRulesQuery() });
  const items = rules?.items ?? [];

  return (
    <Paper sx={{ p: 4, borderRadius: '20px' }}>
      <Stack spacing={2}>
        <CustomTypography variant="h6" sx={{ fontWeight: 700 }}>
          {t('common:affiliatePage.rulesTab.heading')}
        </CustomTypography>
        <CustomTypography color="text.secondary">
          {t('common:affiliatePage.rulesTab.intro')}
        </CustomTypography>
        <Stack component="ol" spacing={1} sx={{ pl: 3, m: 0 }}>
          {items.map((rule, idx) => (
            <li key={idx}>
              <CustomTypography>{rule}</CustomTypography>
            </li>
          ))}
        </Stack>
      </Stack>
    </Paper>
  );
}
